const production = {
  apiUrl: 'https://api.halteverbot123.de/api/',
  hostUrl: 'https://www.halteverbot123.de',
  redirectUrl: 'https://www.halteverbot123.de/index.html',
  paypalPlusMode: 'live',
};


const test = {};

const local = {
  apiUrl: 'http://localhost:8081/api/',
  hostUrl: 'http://localhost:8080',
  redirectUrl: 'http://localhost:8080/index.html',
  paypalPlusMode: 'sandbox'
};

let globalConfig = null;

const config = () => {
  if (globalConfig) return globalConfig;

  if (process.env.NODE_ENV === 'production') {
    globalConfig = production;
  } else if (process.env.NODE_ENV === 'test') {
    globalConfig = Object.assign(production, test);
  } else {
    globalConfig = Object.assign(production, test, local);
  }

  return globalConfig;
};

export default config();
